export default __webpack_public_path__ + "static/media/logo.105b8e09.svg";